
import { useState } from "react";
import { useLocation } from 'react-router-dom';

import { useQuery } from "@tanstack/react-query";

import { IconButton, Button } from "@mui/material";
import TuneIcon from '@mui/icons-material/Tune';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExcel} from '@fortawesome/free-solid-svg-icons';
import { Dropdown, Menu, Space, DatePicker } from 'antd';

import * as XLSX from 'xlsx';

import authAxios from "../components/authAxios";

import moment from 'moment';

import DashboardHeader from "../components/DashboardHeader";
import './EndMonthReport.css'
import Loading from "../components/Loading";


const PropertyBalanceReport = () => {
    const location = useLocation();
    const [reportMonth, setReportMonth] = useState(moment().format('MM'))
    const [reportYear, setReportYear] = useState(moment().format('YYYY'))

    const { data: propertyBalanceReport, isLoading } = useQuery({
        queryKey: ['property-balance-report', reportMonth, reportYear],
        queryFn: async () => {
            const response = await authAxios.get(`/accounting/property-balance-report/`, {
                params: {
                    month: reportMonth,
                    year: reportYear,
                }
            });
            return response.data
        },
    });


    if (isLoading) return <Loading loading={true} />;
    const { headers = [], rows = [], totals } = propertyBalanceReport;

    const downloadXLS = () => {

        // const worksheetData = propertyBalanceReport.report_data.map(data => ({
        const worksheetData = rows.map(data => ({
            'Name': data.name,
            'Current': data['Current'],
            '31-60': data['31-60'],
            '61-90': data['61-90'],
            '91-120': data['91-120'],
            '+120': data['+120'],
            'Total': data['Total'],
        })); 

        const totalsRow = {
            'Name': 'TOTALS',
            'Current': totals['Current'],
            '31-60': totals['31-60'],
            '61-90': totals['61-90'],
            '91-120': totals['91-120'],
            '+120': totals['+120'],
            'Total':totals['Total'],
        }; 

        worksheetData.push(totalsRow);

        // Convert data to worksheet
        const ws = XLSX.utils.json_to_sheet(worksheetData);

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Property Balance Report');

        XLSX.writeFile(wb, `Property_Balance_Report_${reportMonth}_${reportYear}.xlsx`);
    };

    const onChange = (date, dateString) => {
        // console.log(date);
        setReportMonth(date.month()+1)
        setReportYear(date.year())
      };

    const menu = (
        <Menu>
            <form className="filter-form">
                <Space direction="vertical">
                    <DatePicker onChange={onChange} picker="month" placement="bottomRight" />
                </Space>
            </form>
        </Menu>
      );
    const reportPreTitle="PERIOD "+reportMonth+"/"+reportYear

    // a helper function to check if a column has data
    // const hasColumnData = (columnName) => {
    //     return propertyBalanceReport.report_data.some(row => row[columnName] !== 0 && row[columnName] !== null && row[columnName] !== undefined);
    //   };

    // const formatNumber = (number) => {
    //     return number.toLocaleString('en-UK', {
    //       minimumFractionDigits: 2,
    //       maximumFractionDigits: 2,
    //     });
    //   }


    return (
        <div className="dashboard-main end-month-report expense-schedule">
            <section className="dashboard-content">
                <div className="dashboard-content-header-nav">
                    <DashboardHeader dashboardTitle="Property Balance Report" dashboardPreTitle={reportPreTitle} />
                    <div className="dashboard-content-header-nav-icons">
                        <IconButton onClick={downloadXLS}>
                            <FontAwesomeIcon className="menu-icon" icon={faFileExcel} />
                        </IconButton>
                        <Dropdown overlay={menu} trigger={['click']} placement="bottomRight" arrow>
                      
                        <Button className="menu-button-filter" variant="outlined" startIcon={<TuneIcon />}>
                            Filter
                        </Button>

                    </Dropdown>
                    </div>
                
                </div>
                <div className="table-container">


                <table >
                        <thead>
                            <tr>
                                <th>NO</th>
                                {headers.map(data => (
                                    <th key={data}>{data.toUpperCase()}</th>
                                ))}
                            </tr>
                        </thead>
                          
                        <tbody >
                            {rows.map((data, index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                {headers.map(hdr => (
                                    <td key={hdr}>{data[hdr].toLocaleString()}</td>
                                ))}
                            </tr>
                            ))}

                        </tbody>
                        {totals && (
                            <tfoot>
                                <tr>
                                    <td></td>
                                    {headers.map(hdr => (
                                        <td key={hdr}>
                                            {hdr === "name"
                                                ? "TOTALS"
                                                : totals[hdr].toLocaleString()
                                            }
                                        </td>
                                    ))}
                                </tr>
                            </tfoot>
                        )}


                </table>

                </div>



            </section>
        </div>
    );
};

export default PropertyBalanceReport;


